import { ChangeDetectorRef, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ContentTypes } from '../activities/activities.enum';
import { FileType } from './file-type';

export abstract class FileDownload {
  public titleToDisplay: string;
  public popupPublicURL: string;
  public protectedPublicURL: SafeResourceUrl;
  public popupVisible = false;
  public fileTypeContext: FileType = new FileType();
  public downloadLink: string;
  public isDownloadFile: boolean;
  public typeOfContent: ContentTypes = ContentTypes.UNSUPPORTED_TYPE;

  private sanitizer = inject(DomSanitizer);
  protected changeDetector = inject(ChangeDetectorRef);

  public hidePopup(): void {
    this.popupPublicURL = undefined;
    this.popupVisible = false;
    this.typeOfContent = ContentTypes.UNSUPPORTED_TYPE;
  }

  public changePopupVisible(): void {
    this.popupVisible = !(
      this.typeOfContent === ContentTypes.UNSUPPORTED_TYPE || this.typeOfContent === ContentTypes.DOC_TYPE
    );
  }

  public downloadURL(): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.downloadLink);
  }

  public openingFile(url: string, content: string): void {
    this.showPopup(content);

    if (!this.popupVisible) {
      this.downloadFile(url);
    }
  }

  protected showPopup(content: string): void {
    switch (true) {
      case this.fileTypeContext.isImage(content):
        this.typeOfContent = ContentTypes.IMAGE_TYPE;
        break;
      case this.fileTypeContext.isPdf(content):
        this.typeOfContent = ContentTypes.PDF_TYPE;
        break;
      case this.fileTypeContext.isVideo(content):
        this.typeOfContent = ContentTypes.VIDEO_TYPE;
        break;
      case this.fileTypeContext.isDoc(content):
        this.typeOfContent = ContentTypes.DOC_TYPE;
        break;
      case this.fileTypeContext.isAudio(content):
        this.typeOfContent = ContentTypes.AUDIO_TYPE;
        break;
      default:
        break;
    }

    this.changePopupVisible();

    this.changeDetector.detectChanges();
  }

  protected generateProtectedUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  protected downloadWithBlob(url: string, name: string): void {
    const xhr: XMLHttpRequest = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.responseType = 'blob';
    xhr.onload = function (): void {
      if (this.status === 200) {
        const link: HTMLAnchorElement = document.createElement('a');
        link.href = window.URL.createObjectURL(this.response as Blob);
        link.download = name;
        link.click();
      }
    };
    xhr.send();
  }
  /**
   * @description Downloads files with setted interval.
   * @param { string } link Link to download.
   */
  protected downloadFile(link: string): void {
    const linkElements: string[] = link.split('?')[0].split('/');
    this.downloadLink = decodeURIComponent(linkElements[linkElements.length - 1]);

    this.downloadWithBlob(link, this.downloadLink);
  }
}
